import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import _ from 'lodash';
import injectReducer from '@utils/injectReducer';
import injectSaga from '@utils/injectSaga';
import SectionLoading from '@components/SectionLoading';
import { Wrapper } from './styles';
import { getCurrentPoll as getCurrentPollAction } from './actions';
import reducer from './reducer';
import saga from './saga';
import SkillPartHeader from '../../../../components/SkillPartHeader';
import PollClient from '@shared/Resources/Poll/Client';
import POPUP_TYPES from '../../../../../App/containers/PopUp/types';
import { openPopUp as openPopUpAction } from '../../../../../App/containers/PopUp/actions';

export class Poll extends Component {
  componentDidMount() {
    const { skill, skillpartIndex, getCurrentPoll } = this.props;
    getCurrentPoll(skill.Polls[skillpartIndex].id);
  }

  componentDidUpdate(prevProps) {
    const {
      skill, skillpartIndex, getCurrentPoll, poll, loading,
    } = this.props;

    if (
      prevProps.skillpartIndex !== skillpartIndex ||
      !_.isEqual(prevProps.skill, skill)
    ) {
      getCurrentPoll(skill.Polls[skillpartIndex].id);
    }

    if (
      !loading
      && !_.isEmpty(poll)
      && (prevProps.poll.id !== poll.id || !_.isEqual(poll, prevProps.poll))
    ) {
      this.getAndShowFeedback();
    }
  }

  getAndShowFeedback = () => {
    const { poll, openPopUp, user } = this.props;
    const pollFeedback = poll?.feedback || [];
    if (!pollFeedback.length) return;
    const feedbacks = pollFeedback.filter(
      (fb) => !fb.seenBy.includes(user.id) && !fb?.payload?.isDismiss,
    );
    if (feedbacks.length > 0) {
      openPopUp(POPUP_TYPES.CLINICIAN_FEEDBACK, {
        practiceName: poll.name,
        feedbacks,
        isEnteringPractice: true,
      });
    }
  };

  render() {
    const { skill, loading } = this.props;
    if (loading) {
      return <SectionLoading />;
    }
    return (
      <Wrapper>
        <SkillPartHeader skill={skill} />
        <PollClient
          skillParts={skill.orderedSkillParts}
        />
      </Wrapper>
    );
  }
}

Poll.propTypes = {
  getCurrentPoll: PropTypes.func,
  openPopUp: PropTypes.func,
  skill: PropTypes.object,
  poll: PropTypes.object,
  loading: PropTypes.bool,
  skillpartIndex: PropTypes.number,
  user: PropTypes.object,
};

export const mapStateToProps = (state) => {
  const user = state.getIn(['app', 'authentication', 'user']).toJS();
  const { loading, poll } = state.getIn(['currentPoll']).toJS();
  return {
    loading,
    poll,
    ...(user && { user }),
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    getCurrentPoll: (id, hebrewMock) =>
      dispatch(getCurrentPollAction(id, hebrewMock)),
    openPopUp: (type, props) => dispatch(openPopUpAction(type, props)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'currentPoll', reducer });
const withSaga = injectSaga({ key: 'currentPoll', saga });

export default compose(withReducer, withSaga, withConnect)(Poll);
